import ReactDOM from 'react-dom/client'
import {
  InitialPageLoadProvider,
  registerVitePreloadErrorRecovery,
  reportCaughtError,
  setCurrentAppRoutes,
} from '@joyful/ui/app'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import './tailwind.css'
import './overrides.css'
import '@xyflow/react/dist/style.css'
import { router } from './routes'
import { createPath, RouterProvider } from 'react-router-dom'
import { StrictMode } from 'react'
import { env } from '@/env'

setCurrentAppRoutes(router.routes)

registerVitePreloadErrorRecovery({
  getPendingNavigationPath() {
    const pendingLocation = router.state.navigation.location
    return pendingLocation ? createPath(pendingLocation) : null
  },
})

const root = document.getElementById('root')
if (root === null) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(root).render(
  <StrictMode>
    <NuqsAdapter>
      <InitialPageLoadProvider
        environment={
          import.meta.env.MODE === 'development'
            ? 'development'
            : env.VITE_JOYFUL_ENV
        }
      >
        <RouterProvider
          router={router}
          onError={(error, { errorInfo }) => {
            reportCaughtError({ error, errorInfo })
          }}
        />
      </InitialPageLoadProvider>
    </NuqsAdapter>
  </StrictMode>,
)

if (
  import.meta.env.PROD &&
  window.isSecureContext &&
  'serviceWorker' in window.navigator
) {
  window.navigator.serviceWorker
    .register('/pwa.js', { scope: '/', updateViaCache: 'none' })
    .catch((error) => {
      console.warn('Unable to enable desktop offline support.', error)
    })
}
